/**
 * dashboardGrid.context — Contexto interno de DashboardGrid.
 *
 * QUÉ HACE: expone el estado y las acciones de la cuadrícula a cada celda.
 * QUÉ EXPORTA: DashboardGridContext, useDashboardGrid.
 * QUÉ NO DEBE HACER: no renderiza nada (el provider vive en DashboardGrid.tsx).
 */
import { createContext, useContext } from "react";
import type { DashboardGridContextValue } from "./DashboardGrid.types";

export const DashboardGridContext =
  createContext<DashboardGridContextValue | null>(null);

export const useDashboardGrid = (): DashboardGridContextValue => {
  const context = useContext(DashboardGridContext);
  if (!context) {
    throw new Error(
      "DashboardGridItem debe renderizarse dentro de un DashboardGrid.",
    );
  }
  return context;
};
